/**
 * * @module pages/get-involved.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";

const GetInvolved = Backbone.View.extend({
  el: $(document),
  events: {
    "click .show-more.button": "showMoreItems"
  },

  initialize: function () {
    this.render();
  },

  showMoreItems: function () {
    $(".archived-projects .page-block").removeClass("hidden");
    $(".show-more.button").remove();
  },

  addShowMoreBtn: function () {
    var $showMoreBtnWrapper = $(
      ".show-more-container"
    );
    $showMoreBtnWrapper.append(
      '<button class="show-more button">See more</button>'
    );
  },

  showMore: function(){
    const _this = this;
    const $container = $(".archived-projects");
    const $items = $('.page-block',$container);
    const length = $items.length;

    if(length > 4){
      const $items = $('.page-block:not(.item-1):not(.item-2):not(.item-3):not(.item-4)', $container);
      console.log($items);
      $items.addClass("hidden");

      _this.addShowMoreBtn();
    }
  },

  render: function () {
    this.showMore();
  },
});

export default GetInvolved;
